module.exports = __webpack_public_path__ + "img/inventory-transfers.6f8cc20.png";